import { useEffect, useState } from "react";
import { AgentOSLayout } from "@/components/agent-os/AgentOSLayout";
import { apiFetch, Empty, formatDateTime, Pill, Spinner } from "@/components/agent-os/shared";

export default function AgentOSMissions() {
    const [missions, setMissions] = useState(null);
    useEffect(() => { apiFetch("/missions").then((r) => (r.ok ? r.json() : [])).then(setMissions); }, []);

    return (
        <AgentOSLayout title="Missions" subtitle="Controlled multi-agent workflows are defined here before any autonomous execution is allowed.">
            {!missions ? <Spinner /> : missions.length === 0 ? <Empty title="No missions" copy="Mission definitions will appear here." /> : (
                <div className="space-y-6" data-testid="missions-list">
                    {missions.map((mission) => (
                        <article key={mission.mission_id} data-testid={`mission-${mission.mission_id}`} className="border border-ink/10 bg-ivory p-7">
                            <div className="flex flex-wrap items-start justify-between gap-4">
                                <div>
                                    <h2 className="font-serif text-3xl font-medium tracking-tight">{mission.title}</h2>
                                    <p className="mt-2 max-w-3xl text-sm leading-relaxed text-ink/60">{mission.description}</p>
                                </div>
                                <div className="flex gap-2"><Pill value={mission.status} /><Pill value={mission.risk_level} risk /></div>
                            </div>
                            <div className="mt-8 grid gap-px border border-ink/10 bg-ink/10 lg:grid-cols-5">
                                {mission.workflow.map((step) => (
                                    <div key={step.step} className="bg-ivory p-5">
                                        <p className="font-serif text-3xl font-medium text-champagne">{String(step.step).padStart(2, "0")}</p>
                                        <p className="mt-4 text-xs font-semibold uppercase tracking-[0.16em] text-forest">{step.agent_id}</p>
                                        <p className="mt-2 text-sm text-ink/65">{step.action.replace(/_/g, " ")}</p>
                                        <p className="mt-3 text-[10px] uppercase tracking-[0.14em] text-ink/40">Approval: {step.approval}</p>
                                    </div>
                                ))}
                            </div>
                            <div className="mt-5 flex flex-wrap gap-5 text-xs text-ink/50">
                                <span>Max steps: {mission.limits.max_steps}</span>
                                <span>Timeout: {mission.limits.timeout_seconds}s</span>
                                <span>Retries: {mission.limits.retry_limit}</span>
                                <span>Created: {formatDateTime(mission.created_at)}</span>
                            </div>
                        </article>
                    ))}
                </div>
            )}
        </AgentOSLayout>
    );
}
